import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  nickname: 'BPAY Nickname',
  billerCode: 'Biller Code',
  billerName: 'Biller Name',
  crn: 'CRN',
  info: 'Please check your details to ensure they’re correct before proceeding with your payment.',
})
